import { useEffect, useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Cabecalho from '../../components/Cabecalho';
import Rodape from '../../components/Rodape';
import api from '../../api';
import { useCart } from '../../context/CartContext';
import './index.scss';

export default function PagamentoRetorno() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { clearCart } = useCart();

    const payload = useMemo(() => ({
        order_nsu: searchParams.get('order_nsu') || '',
        transaction_nsu: searchParams.get('transaction_nsu') || '',
        slug: searchParams.get('slug') || searchParams.get('invoice_slug') || '',
        capture_method: searchParams.get('capture_method') || '',
        receipt_url: searchParams.get('receipt_url') || ''
    }), [searchParams]);

    useEffect(() => {
        const validarRetorno = async () => {
            if (!payload.order_nsu || !payload.transaction_nsu || !payload.slug) {
                navigate('/pagamento-falhou', { replace: true });
                return;
            }

            try {
                const response = await api.post('/pagamento/status-check', {
                    order_nsu: payload.order_nsu,
                    transaction_nsu: payload.transaction_nsu,
                    slug: payload.slug
                });

                if (response.data?.success && response.data?.paid) {
                    clearCart();
                    const query = new URLSearchParams({
                        order_nsu: payload.order_nsu,
                        capture_method: payload.capture_method || '',
                        receipt_url: payload.receipt_url || ''
                    });
                    navigate(`/pagamento-concluido?${query.toString()}`, { replace: true });
                    return;
                }

                const pendingQuery = new URLSearchParams({ order_nsu: payload.order_nsu });
                navigate(`/pagamento-pendente?${pendingQuery.toString()}`, { replace: true });
            } catch (error) {
                const pendingQuery = new URLSearchParams({ order_nsu: payload.order_nsu });
                navigate(`/pagamento-pendente?${pendingQuery.toString()}`, { replace: true });
            }
        };

        validarRetorno();
    }, [clearCart, navigate, payload]);

    return (
        <section className='container-pagamento-retorno'>
            <Cabecalho />
            <main>
                <div className='checkout-processando-fullscreen'>
                    <div className='loading-produtos'>
                        <svg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 24 24'>
                            <path fill='#131C46' d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z' opacity='0.25' />
                            <path fill='#131C46' d='M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z'>
                                <animateTransform attributeName='transform' dur='0.75s' repeatCount='indefinite' type='rotate' values='0 12 12;360 12 12' />
                            </path>
                        </svg>
                        <h2>Conferindo status do pedido...</h2>
                        <p>Nao feche esta pagina.</p>
                    </div>
                </div>
            </main>
            <Rodape />
        </section>
    );
}
